import { Icon, Tooltip, useGlimmerTheme } from '@innovamat/glimmer-components';
import { Trans } from 'react-i18next';

type Props = {
  tooltipText?: string;
};

function CloudOffIcon({ tooltipText }: Props): JSX.Element {
  const theme = useGlimmerTheme();
  return (
    <Tooltip
      content={
        <Trans i18nKey={tooltipText} components={{ strong: <strong /> }} />
      }
    >
      <Icon
        iconColor={theme.tokens.color.alias.cm.icon['icon-warning'].value}
        icon="CloudOffIcon"
      />
    </Tooltip>
  );
}

export { CloudOffIcon };
